// extracted by mini-css-extract-plugin
export default {"container":"content_container__L2MgS","noSidebar":"content_noSidebar__SyFqC"};